export const RETAIL_SERVICE_GROUP_ID = 24;
export const UPNEEQ_SERIVCE_NAME = 'Upneeq';
export const LATISSE_SERIVCE_NAME = 'Latisse';
export const RETAIL_SERVICES = [UPNEEQ_SERIVCE_NAME, LATISSE_SERIVCE_NAME];
